import { render, staticRenderFns } from "./savePkgModal.vue?vue&type=template&id=23a49caa&scoped=true&"
import script from "./savePkgModal.vue?vue&type=script&lang=js&"
export * from "./savePkgModal.vue?vue&type=script&lang=js&"
import style0 from "./savePkgModal.vue?vue&type=style&index=0&id=23a49caa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a49caa",
  null
  
)

export default component.exports